import { makeAutoObservable } from 'mobx'
import {
  isAdmin,
  isAdministration,
  isDealer,
  isDealerOperator,
  isOperator,
} from '../services/AccountService'
import { openModalFn } from '../utils/controllers/ModalController'
import { getComp } from '../utils/utils/DI'
import RequestsFilterStore from '../views/RequestsManagement/stores/RequestsFilterStore'
import operatorRequestStore from './OperatorRequestStore'
import SelectOrdersStore from './SelectOrdersStore'

class RequestsManagementStore {
  constructor() {
    this.filterStore = new RequestsFilterStore()
    this.ordersStore = getComp('OrdersStore')
    this.operatorStore = operatorRequestStore
    this.selectOrdersStore = new SelectOrdersStore({
      ordersStore: this.ordersStore,
    })
    this.operatorStore.load()
    makeAutoObservable(this)
  }

  openAddRequestDrawer = () => {
    ;(isAdmin() || isOperator() || isDealerOperator() || isAdministration()) &&
      openModalFn['add-request']({
        filterStore: this.filterStore,
        ordersStore: this.ordersStore,
      })
  }

  openRequestDetails = (order) => {
    if (isDealer()) {
      openModalFn['installation-request']({
        id: order.data.id,
        filterStore: this.filterStore,
        ordersStore: this.ordersStore,
      })
      return
    }
    if (
      (isOperator() && this.operatorStore.selectedTab === 0) ||
      (isAdministration() && this.operatorStore.selectedTab === 1)
    ) {
      openModalFn['request-details']({
        id: order.data.id,
        filterStore: this.filterStore,
        ordersStore: this.ordersStore,
        operatorStore: this.operatorStore,
      })
      return
    }
    if (isOperator() && this.operatorStore.selectedTab === 1) {
      openModalFn['request-details']({ id: order.data.id, data: order.data })
      return
    }
    if (isAdmin() || isOperator() || isAdministration()) {
      openModalFn['request-details']({ id: order.data.id })
    }
  }

  reLoadCallback = () => {
    // this.ordersStore
    //   .updateOrder(this.reportOrderDetailsStore.data.id)
    //   .then((order) => {
    //     if (!order) {
    //       this.reportOrderDetailsStore.isOrderEdit = false
    //       this.reportOrderDetailsStore.closeOrderDetails()
    //       return
    //     }
    //     this.reportOrderDetailsStore.setData(order)
    //     this.reportOrderDetailsStore.isOrderEdit = false
    //     if (order.dataCheckingStatus !== 2) {
    //       openModalFn['installation-request']({
    //         id: this.reportOrderDetailsStore.data.id,
    //         ordersStore: this.ordersStore,
    //       })
    //       this.reportOrderDetailsStore.closeOrderDetails()
    //     }
    //     closeModalFn['progress-backdrop']()
    //   })
    //   .finally(() => {
    //     closeModalFn['progress-backdrop']()
    //   })
  }

  get totalCollectionLength() {
    return (isOperator() && this.operatorStore.selectedTab === 0) ||
      (isAdministration() && this.operatorStore.selectedTab === 1)
      ? this.operatorStore.total
      : this.ordersStore.total
  }
}

export default new RequestsManagementStore()
